<template>
  <basic-portlet :bordered="true" border-class="border-info">
    <div class="row">
      <div class="col-12">
        <p><strong>Step 1: Name your live feed</strong></p>
        <p>
          Provide a unique name - this name will be used to generate your output mount point names. Spaces and special characters will be replaced with underscores and appended with the output bitrate.
          <i>My live stream -> My_live_stream_128.mp3</i>
        </p>

        <p><strong>Step 2: Choose your feed and settings</strong></p>
        <p>Select the feed you want to play out as live.</p>
        <p>Select a mode: determines how the feed {{ getItemLabel() }}s will be played out:</p>
        <ul>
          <li>Normal: play the {{ getItemLabel() }}s in the order they are represented in the feed</li>
          <li>Shuffle: play the {{ getItemLabel() }}s in a random order every time the live feed is reloaded</li>
          <li>Random: With each play, a random file will be selected from the feed</li>
        </ul>
        <p>Select a reload mode: determines the triggers that will reload the live feed contents:</p>
        <ul>
          <li>Never: reload must be triggered manually</li>
          <li>Seconds: reload will be triggered after X number of seconds</li>
        </ul>

        <p><strong>Step 3: Select your outputs</strong></p>
        <p>Select a format: MP3 and AAC-HE v2 currently available</p>
        <p>Select a bitrate: available bitrates are determined by the output format. Higher bitrates use more bandwidth and are less mobile-friendly</p>
      </div>
    </div>
  </basic-portlet>
</template>

<script>
import BasicPortlet from "VueComponents/BasicPortlet";

export default {
  components: { BasicPortlet },
};
</script>
